<template>
  <div data-canny></div>
</template>

<script>
  import { useScriptTag } from '@vueuse/core'

export default {
  props: {
    theme: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      cannyBoardToken: 'a8114934-2db0-2f9f-b6cb-1b8fc7d505d0'
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    }
  },
  async mounted() {
    if (!window.Canny) {
      window.Canny = window.Canny || function () {
        (window.Canny.q = window.Canny.q || []).push(arguments)
      }
    }

    const { load } = useScriptTag(
      'js/canny/canny-sdk.js',
      async () => {
        await this.$store.dispatch('getUserCannyToken')
        window.Canny('render', { 
          boardToken: this.cannyBoardToken,
          basePath: null,
          theme: this.theme,
          ssoToken: this.user?.canny?.token
        })
      },
      {
        manual: false,
        attrs: { 
          id: 'canny-sdk',
          async: true
        }
      }
    )
    await load()
  },
  beforeUnmount() {
    if (window.Canny) {
      window.Canny('destroy')
      window.Canny = null
    }
  }
}
</script>
